import { AlertTriangle, Info, X } from 'lucide-react';
import { usePlatformSettings } from '@/hooks/usePlatformSettings';
import { useState, useEffect } from 'react';

export function AnnouncementBanner() {
  const { announcement } = usePlatformSettings();
  const [isVisible, setIsVisible] = useState(true);

  // Consider an announcement closed if the user dismisses exactly this title+message
  // Incorporate version or timestamp to invalidate dismissals when updated
  const announcementKey = `dismissed_announcement_${announcement?.title}_${announcement?.startDate}_${announcement?.version || ''}`;

  useEffect(() => {
    if (announcement?.active) {
      const isDismissed = localStorage.getItem(announcementKey);
      if (isDismissed === 'true' && announcement.type !== 'maintenance') {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    }
  }, [announcementKey, announcement?.active, announcement?.type]);

  if (!announcement?.active || !isVisible) {
    return null;
  }

  const isMaintenance = announcement.type === 'maintenance';
  const isWarning = announcement.type === 'warning';

  const bgColor = isMaintenance 
    ? 'bg-amber-500/10 dark:bg-amber-500/20 text-amber-900 dark:text-amber-200 border-amber-500/20' 
    : isWarning 
    ? 'bg-red-500/10 dark:bg-red-500/20 text-red-900 dark:text-red-200 border-red-500/20'
    : 'bg-primary/10 dark:bg-primary/20 text-primary-foreground dark:text-primary-foreground border-primary/20';

  const Icon = isMaintenance || isWarning ? AlertTriangle : Info;

  const handleDismiss = () => {
    localStorage.setItem(announcementKey, 'true');
    setIsVisible(false);
  };

  return (
    <div className={`w-full py-3 px-4 sm:px-6 lg:px-8 border-b ${bgColor} relative z-50`}>
      <div className="max-w-7xl mx-auto flex items-start sm:items-center justify-between gap-4">
        <div className="flex items-start sm:items-center gap-3">
          <Icon className="w-5 h-5 flex-shrink-0 mt-0.5 sm:mt-0" />
          <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
            {announcement.title && (
              <span className="font-semibold">{announcement.title}:</span>
            )}
            <span className="text-sm font-medium">{announcement.message}</span>
          </div>
        </div>
        
        {/* Only allow dismiss if it's not a strict maintenance banner */}
        {!isMaintenance && (
          <button 
            onClick={handleDismiss}
            className="p-1 hover:bg-black/5 dark:hover:bg-white/5 rounded-full transition-colors flex-shrink-0"
            aria-label="Cerrar aviso"
          >
            <X className="w-4 h-4" />
          </button>
        )}
      </div>
    </div>
  );
}
